import { Reducer } from 'redux';
import regionsConfigurationSlice, {
	REGIONS_CONFIGURATION_KEY_IN_STORE,
} from './slice';
import { regionsConfigurationSaga } from './sagas';

export class RegionsConfigurationModule {
	getRootKeyInStore(): string {
		return REGIONS_CONFIGURATION_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return regionsConfigurationSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return regionsConfigurationSaga;
	}
}

export const moduleInstance = new RegionsConfigurationModule();
